import {
  type INumberFieldProps,
  type ITextFieldProps,
  NumberField,
} from '@procurify/ui'
import { useSelector } from 'react-redux'

import { useFormatPrice } from '@webapp/core/hooks/useFormatPrice'
import { makeSelectPriceDecimalPlaces } from '@webapp/core/stores/global'

export interface IPriceFieldProps extends ITextFieldProps, INumberFieldProps {
  mdp?: boolean
}

export const PriceField = ({
  mdp = true,
  decimalPlaces,
  value,
  defaultValue,
  inputProps,
  ...otherProps
}: IPriceFieldProps) => {
  const formatPrice = useFormatPrice({ mdp })
  const priceDecimalPlaces = useSelector(makeSelectPriceDecimalPlaces())

  const priceValue = formatPrice(value as number, '') || value
  const defaultPriceValue = formatPrice(defaultValue as number, '') || value

  const numberFieldProps = {
    allowTrailingZeros: false,
    minimumDecimalScale: 2,
    thousandSeparator: true,
  }

  return (
    <NumberField
      decimalPlaces={decimalPlaces || priceDecimalPlaces}
      inputProps={{
        ...numberFieldProps,
        ...inputProps,
      }}
      value={priceValue}
      defaultValue={defaultPriceValue}
      {...otherProps}
    />
  )
}

PriceField.displayName = 'PriceField'
